import {css} from '@emotion/core'
import styled from '@emotion/styled'
import React from 'react'

import {brands, defaultBrand} from '@daedalus/core/src/brand/config'
import ContentWrapper from '../../../designSystem/helpers/ContentWrapper'
import MobileCurrencySelector from './CurrencySelector/Mobile'
import GetHelpLink from './GetHelpLink'
import MobileLanguageSelector from './LanguageSelector/Mobile'

import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import {useIsReferralProgramEnabled} from '../../../../hooks/useIsReferralProgramEnabled'
import ArrowLink from './ArrowButton'
import {PropsType} from './types'
import {InviteFriendsToPlus} from './InviteFriendsToPlus'

const RowWrapper = styled('div')(
  ({theme}) => css`
    padding: ${theme.layout.spacing.s600}px 0;
    border-bottom: solid 1px ${theme.colors.navMenuBorder};
  `
)

const FindHotelMembership = ({
  onShowMembershipOverlay
}: Pick<PropsType, 'onShowMembershipOverlay'>) => (
  <RowWrapper>
    <ArrowLink onClick={onShowMembershipOverlay}>
      <FormattedMessageWrapper
        id="membership.findhotelMembership"
        defaultMessage="FindHotel membership"
      />
    </ArrowLink>
  </RowWrapper>
)

const PreferenceSelectorMobile = ({
  availableLanguages,
  brand = defaultBrand,
  currentLanguage,
  currenciesList,
  popularCurrenciesList,
  currentCurrency,
  onChangeLanguage,
  onChangeCurrency,
  hasLanguageSelector = true,
  hasCurrencySelector = true,
  onShowMembershipOverlay
}: PropsType) => {
  const showFhMembership = brands.etrip.name !== brand.name
  const isReferralProgramEnabled = useIsReferralProgramEnabled(brand)

  return (
    <ContentWrapper paddingTopSize="s000">
      {hasLanguageSelector && (
        <RowWrapper>
          <MobileLanguageSelector
            availableLanguages={availableLanguages}
            currentLanguage={currentLanguage}
            onChangeLanguage={onChangeLanguage}
          />
        </RowWrapper>
      )}

      {hasCurrencySelector && (
        <RowWrapper>
          <MobileCurrencySelector
            currenciesList={currenciesList}
            popularCurrenciesList={popularCurrenciesList}
            currentCurrency={currentCurrency}
            onChangeCurrency={onChangeCurrency}
          />
        </RowWrapper>
      )}

      {isReferralProgramEnabled && <InviteFriendsToPlus />}

      {showFhMembership && (
        <FindHotelMembership
          onShowMembershipOverlay={onShowMembershipOverlay}
        />
      )}

      <RowWrapper>
        <GetHelpLink brand={brand} />
      </RowWrapper>
    </ContentWrapper>
  )
}

export default PreferenceSelectorMobile
